window.Branch = window.Branch || {};
window.Branch.functions = window.Branch.functions || {};

window.Branch.functions.getStyle = function(el, styleProp) {
    var value, defaultView = (el.ownerDocument || document).defaultView;
    if (defaultView && defaultView.getComputedStyle) {
        styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
        return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
    } else if (el.currentStyle) { // IE
        styleProp = styleProp.replace(/\-(\w)/g, function(str, letter) {
            return letter.toUpperCase();
        });
        value = el.currentStyle[styleProp];
        if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
            return (function(value) {
                var oldLeft = el.style.left,
                    oldRsLeft = el.runtimeStyle.left;
                el.runtimeStyle.left = el.currentStyle.left;
                el.style.left = value || 0;
                value = el.style.pixelLeft + "px";
                el.style.left = oldLeft;
                el.runtimeStyle.left = oldRsLeft;
                return value;
            })(value);
        }
        return value;
    }
}

/* Function that returns a srcset when passed an image URL */
window.Branch.functions.returnSrcSet = function(productImageUrl, cutOff) {
  let returnedSrcSet;
  if(productImageUrl.includes('?v=')){
    returnedSrcSet = `${productImageUrl}&width=90 90w, ${productImageUrl}&width=180 180w, ${productImageUrl}&width=360 360w, ${productImageUrl}&width=540 540w, ${productImageUrl}&width=720 720w, ${productImageUrl}&width=900 900w, ${productImageUrl}&width=1080 1080w, ${productImageUrl}&width=1280 1280w, ${productImageUrl}&width=1440 1440w`;
  } else {
    returnedSrcSet = `${productImageUrl}?width=90 90w, ${productImageUrl}?width=180 180w, ${productImageUrl}?width=360 360w, ${productImageUrl}?width=540 540w, ${productImageUrl}?width=720 720w, ${productImageUrl}?width=900 900w, ${productImageUrl}?width=1080 1080w, ${productImageUrl}?width=1280 1280w, ${productImageUrl}?width=1440 1440w`;
  }
  if(cutOff) {
    if(cutOff == 90 || cutOff == 180 || cutOff == 360 || cutOff == 540 || cutOff == 720 || cutOff == 900 || cutOff == 1080 || cutOff == 1280 || cutOff == 1440){
      let sizesArray = [90, 180, 360, 540, 720, 900, 1080, 1280, 1440];
      let sizesIndex = sizesArray.indexOf(cutOff);
      let newCutOff = sizesArray[sizesIndex + 1] || 1440; 
      const entries = returnedSrcSet.split(',');
      const cutOffIndex = entries.findIndex(src => src.includes(`width=${newCutOff}`));
      
      if (cutOffIndex !== -1) {
        returnedSrcSet = entries.slice(0, cutOffIndex).join(', ');
      }
    }
  }
  return returnedSrcSet;
}

/* Function that returns a string it's passed with the first letter of each word capitalized */
window.Branch.functions.capitalizeWords = function(str) {
  return str.split(' ').map(word => {
      if (word === word.toUpperCase()) {
          return word.charAt(0) + word.slice(1).toLowerCase();
      }
      return word;
  }).join(' ');
}

window.Branch.functions.isTouchDevice = function() {
    return (('ontouchstart' in window) ||
       (navigator.maxTouchPoints > 0) ||
       (navigator.msMaxTouchPoints > 0));
  }

window.Branch.functions.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    var loadFunction = function() {
      imagesLoaded++;
      if(imagesLoaded==images.length) {
        callback();
      }
    };
    images.each(function(){
      var img = new Image();
      img.onload = loadFunction;
      img.onerror = loadFunction;
      if($(this).attr('src')){
        img.src = $(this).attr('src');
      }
      if($(this).attr('srcset')){
        img.srcset = $(this).attr('srcset');
      }
    });
  };

  window.Branch.functions.detectWrap = function(items) {
    var wrappedItems = [];
    var prevItem = {};
    var currItem = {};
    
    for (var i = 0; i < items.length; i++) {
      currItem = items[i].getBoundingClientRect();
      if (prevItem && prevItem.top < currItem.top) {
        wrappedItems.push(items[i]);
      }
      prevItem = currItem;
    };

    var wrapped = wrappedItems.length > 0 ? true : false;

    return wrapped;
  }

  window.Branch.functions.fixBody = function(type) {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    if(type == "fix"){
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollY}px`;
      document.body.setAttribute('data-fixed', true)
    } else {
      document.body.removeAttribute('data-fixed')
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.removeProperty('width');
      // window.scrollTo({left: 0, top: parseInt(scrollY || '0') * -1, behavior: 'instant'});
    }
  }

  window.Branch.functions.returnWindowWidth = function(){
    var width = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;
    return width
  }
  
  window.Branch.functions.returnWindowHeight = function(){
    var height = window.innerHeight
|| document.documentElement.clientHeight
|| document.body.clientHeight;
    return height
  }

  window.Branch.functions.numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

window.Branch.functions.stripVariantText = function(string, variantTextReplacementMetafield){
  let strippedString = string.replaceAll(' vegan leather', '').replaceAll(' Vegan Leather', '');
  if(variantTextReplacementMetafield){
    let downcaseString = strippedString.toLowerCase();
    variantTextReplacementMetafield.forEach((word) => {
      downcaseString = downcaseString.replaceAll(word, '')
    });
    strippedString = downcaseString.trim().replace(/\b\w/g, char => char.toUpperCase());
  }
  return strippedString;
}

window.Branch.functions.returnSingleSrc = function(type, url, width){
  let singleSrc = '';
  let urlTemp = url;

  if(type == 'srcset'){
    urlTemp = url.split(',')[0].trim().split(' ')[0];
  }

  if(urlTemp.includes('&width')){
    urlTemp = urlTemp.split('&width')[0]
  } else if (urlTemp.includes('?width')){
    urlTemp = urlTemp.split('?width')[0]
  }

  if(urlTemp.includes('?v=')){
    urlTemp = `${urlTemp}&width=${width}`
  } else {
    urlTemp = `${urlTemp}?width=${width}`
  }
  singleSrc = urlTemp;

  return singleSrc;
}

window.Branch.functions.debounce = function(func, wait) {
  let timeout;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, arguments), wait);
  };
}

window.Branch.functions.addEventListenerWithArg = function(element, event, handler, arg) {
  const listener = function(e) {
    handler(e, arg);
  };
  element.addEventListener(event, listener);

  return listener;
}

window.Branch.functions.returnCookieURL= function(cookieName){
  let cookieUrl = document.cookie
  .split("; ")
  .find((row) => row.startsWith(`${cookieName}=`))
  ?.split("=")[1]; 
  let url = "/"

  if(cookieUrl !== undefined && cookieUrl !== null && cookieUrl !== ''){
      url = cookieUrl;
  }

  return url
}

window.Branch.functions.getElementWithClass = function(event, className) {
  const target = event.target;

  if (target.classList.contains(className)) {
      return target;
  }

  let currentElement = target;
  while (currentElement.parentElement) {
      currentElement = currentElement.parentElement;
      if (currentElement.classList.contains(className)) {
          return currentElement;
      }
  }

  const matchingChild = target.querySelector(`.${className}`);
  if (matchingChild) {
      return matchingChild;
  }

  return null;
}

window.Branch.functions.isElementVisibleOrBelow = function(selector) {
  const element = document.querySelector(selector);
    if (!element) {
        return false; // Element doesn't exist
    }

    

    const rect = element.getBoundingClientRect();
    return (
        rect.bottom > 0 // Element is either within or below the viewport
    );
};

window.Branch.functions.isElementPartiallyOffScreen = function(selector) {
  const element = document.querySelector(selector);
  if (!element) {
      console.error(`Element with selector ${selector} not found`);
      return;
  }
  
  const rect = element.getBoundingClientRect();
  
  const isPartiallyOffScreen = (
      rect.top < 0 || 
      rect.left < 0 || 
      rect.bottom > window.innerHeight || 
      rect.right > window.innerWidth 
  );
  
  return isPartiallyOffScreen;
}

window.Branch.functions.updateHeightInCategory = function(allParentsSelector, allChildrenSelector){
  let parentElements = document.querySelectorAll(`${allParentsSelector}`);
  parentElements.forEach((parentElement) => {
      let childElements = parentElement.querySelectorAll(`${allChildrenSelector}`)
      let highestHeight = 0;
      childElements.forEach((childElement) => {
          childElement.style.removeProperty("height");
          if(childElement.offsetHeight > highestHeight){
              highestHeight = childElement.offsetHeight
          }
      });
      childElements.forEach((childElement) => {
          childElement.style.height = `${highestHeight}px`;
      })
  })
}

window.Branch.functions.defineInitFunctionSafely = function(functionName, func) {
  // Check if the function is already defined in the global scope
  if (typeof window[functionName] === "function") {
    console.warn(`Function "${functionName}" is already defined. New function not initialized.`);
    return;
  }

  // Flag to ensure the function only executes once
  let hasExecuted = false;

  // Define the new function
  window[functionName] = function (...args) {
      if (hasExecuted) {
          console.warn(`Function "${functionName}" has already been executed.`);
          return;
      }
      hasExecuted = true;
      func(...args);
  };
}

window.Branch.functions.capitalizeFirstLetter = function (val) {
  val = String(val);
  if (!val) return val; // Handle empty strings
  return val.charAt(0).toUpperCase() + val.slice(1);
};

window.Branch.functions.updateVariantParam = function(url, name, value) {
  const baseUrl = window.location.origin;
  if (!url.startsWith(baseUrl)) {
    url = baseUrl + url;
  }
  const urlObj = new URL(url); 
  urlObj.searchParams.set(name, value); 
  return urlObj.toString();
}

var discountCodeData = document.querySelector('#discount-code-data') ? JSON.parse(document.querySelector('#discount-code-data').innerText) : {};
window.Branch.functions.returnSalesTagText = function(salesTag, type, presetBundleData){
  let salesTagText = '';

  if(type != 'fromHandle' && salesTag.getAttribute('data-sale-text') != undefined && salesTag.getAttribute('data-sale-text') != ""){
    salesTagText = salesTag.getAttribute('data-sale-text');
  } else if(discountCodeData){
    let productHandle = type == 'fromHandle' ? salesTag : salesTag.getAttribute('data-product-handle');
    if(discountCodeData.discount_code_1_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.discount_code_1_amount != undefined && discountCodeData.discount_code_1_amount > 0){
      salesTagText = `save ${discountCodeData.discount_code_1_amount}%`;
      if(discountCodeData.discount_code_1_special_swatch_text != ""){
        salesTagText = discountCodeData.discount_code_1_special_swatch_text;
      }
    } else if(discountCodeData.discount_code_2_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.discount_code_2_amount != undefined && discountCodeData.discount_code_2_amount > 0){
      salesTagText = `save ${discountCodeData.discount_code_2_amount}%`;
      if(discountCodeData.discount_code_2_special_swatch_text != ""){
        salesTagText = discountCodeData.discount_code_2_special_swatch_text;
      }
    } else if(discountCodeData.discount_code_auto_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.discount_code_auto_amount != undefined && discountCodeData.discount_code_auto_amount > 0){
      salesTagText = `save ${discountCodeData.discount_code_auto_amount}%`;
    }
  }
  return salesTagText;
}

window.Branch.functions.returnDiscountCodeUpdates = function(currentPrice, originalPrice, discountAmount, discountMessage, productHandle){
  let discountCodeLimit = 999999999999;
  if (discountCodeData.discount_code_1_product_handles.replaceAll(' ', '').split(",").includes(productHandle)) {
    if(originalPrice == null || originalPrice == 0){originalPrice = currentPrice};
    discountAmount = discountCodeData.discount_code_1_amount;
    currentPrice = currentPrice * (1 - discountAmount / 100);
    discountMessage = discountCodeData.discount_code_1_message;
    discountCodeLimit = discountCodeData.discount_code_1_limit;
  }

  if (discountCodeData.discount_code_2_product_handles.replaceAll(' ', '').split(",").includes(productHandle)) {
    if(originalPrice == null || originalPrice == 0){originalPrice = currentPrice};
    discountAmount = discountCodeData.discount_code_2_amount;
    currentPrice = currentPrice * (1 - discountAmount / 100);
    discountMessage = discountCodeData.discount_code_2_message;
    discountCodeLimit = discountCodeData.discount_code_2_limit;
  }

  if (discountCodeData.discount_code_auto_product_handles.replaceAll(' ', '').split(",").includes(productHandle)) {
    if(originalPrice == null || originalPrice == 0){originalPrice = currentPrice};
    discountAmount = discountCodeData.discount_code_auto_amount;
    currentPrice = currentPrice * (1 - discountAmount / 100);
    discountMessage = discountCodeData.discount_code_auto_message;
    discountCodeLimit = discountCodeData.discount_code_auto_limit;
  }

  return {'currentPrice': parseInt(currentPrice), 'originalPrice': parseInt(originalPrice), 'discountAmount': discountAmount, 'discountMessage': discountMessage, 'discountCodeLimit': discountCodeLimit};
}

window.Branch.functions.truncateText = function (text, maxWidth, font = "16px Quicksand") {
  const ctx = document.createElement("canvas").getContext("2d");
  ctx.font = font;
  if (ctx.measureText(text).width <= maxWidth) return text;

  while (text.length && ctx.measureText(text + "...").width > maxWidth) 
      text = text.slice(0, -1);

  return text + "...";
}


window.Branch.functions.updateSideCartPricing = function(type){
  let topSelector = type == 'side-cart' ? '#side-cart' : (type == 'quiz-results' ? '.results-page .summary' : '#cart');
  let itemPriceSelector = type == 'quiz-results' ? '.item .price.igPrice' : '.item .price:not(.igPrice)';
  let itemPrices = document.querySelectorAll(`${topSelector} ${type == 'side-cart' ? '.cart-items form' : (type == 'quiz-results' ? '.items' : 'form .items')} ${itemPriceSelector}`);
  let cartTotalOriginalPrice = 0;
  let cartTotalDiscountedPrice = 0;
  let cartTotalDiscount = 0;
  let orderLevelDiscountTotal = 0;
  let orderLevelDiscountMessage = '';
  const perProductQuantities = {};
  document.querySelectorAll(`${topSelector} ${type == 'side-cart' ? '.cart-items' : '.items'} ${type == 'quiz-results' ? '' : 'form '}.item`).forEach(item => {
    const handle = item.getAttribute('data-product-handle');
    let quantity = 0;
    if (type == 'quiz-results') {
      const quantitySpan = item.querySelector('.quantity span');
      quantity = parseInt(quantitySpan?.textContent, 10) || 0;
    } else {
      const quantityInput = item.querySelector('.quantity-box input[type="number"]');
      quantity = parseInt(quantityInput?.value, 10) || 0;
    }
    if (!perProductQuantities[handle]) {perProductQuantities[handle] = 0};
    perProductQuantities[handle] += quantity;
  });

  itemPrices.forEach((itemPrice) => {
    if (type == 'quiz-results') {
      // Simplified handling for quiz results - just add discount message and retail price
      let discountDataScript = itemPrice.closest('.edit-item').querySelector('.discount-allocation-data');
      if (!discountDataScript) return;

      let discountData = JSON.parse(discountDataScript.innerText);
      let discountMessage = '';

      let currentPrice = parseInt(itemPrice.getAttribute('data-line-price'));
      let originalPrice = parseInt(itemPrice.getAttribute('data-original-price'));

      discountData.forEach((discountLine) => {
        if(discountLine.target_type == 'line_item' && discountLine.target_selection != 'all'){
          discountMessage = `<p> with <strong>'${discountLine.title}'</strong></p>`;
        }
      });

      // Show retail price if there's a discount
      if (originalPrice > currentPrice) {
        let moneySpan = itemPrice.querySelector('.money');
        if (moneySpan && !itemPrice.querySelector('.retail-price')) {
          let retailPriceHtml = `<span class="money retail-price" style="text-decoration: line-through; margin-right: 0.5em;opacity: .4;">${Shopify.formatMoney(originalPrice, Simplistic.formatMoney)}</span>`;
          moneySpan.insertAdjacentHTML('beforebegin', retailPriceHtml);
        }
      }

      let titleQttyPriceDiv = itemPrice.closest('.title-qtty-price');
      let parentContainer = itemPrice.closest('.item');
      if(discountMessage != '' && parentContainer && !parentContainer.querySelector('.cart-discount-code-message')){
        titleQttyPriceDiv.insertAdjacentHTML('afterend', `<div class="cart-discount-code-message">${discountMessage}</div>`);
      } else if(discountMessage != '' && parentContainer && parentContainer.querySelector('.cart-discount-code-message')) {
        parentContainer.querySelector('.cart-discount-code-message').innerHTML = discountMessage;
      }
      return;
    }

    // Original logic for side-cart and cart-page
    let currentQuantity =  parseInt(itemPrice.querySelector('.deal').getAttribute('data-quantity-multiplier'));
    let newQuantity = parseInt(itemPrice.closest('.grid').querySelector('.quantity-box input[type="number"').value);
    itemPrice.querySelector('.deal').setAttribute('data-quantity-multiplier', newQuantity)
    let currentPrice = newQuantity * (parseInt(itemPrice.querySelector('.deal').getAttribute('data-price')) / currentQuantity);
    let productHandle = itemPrice.closest('.item').getAttribute('data-product-handle');
    let originalCurrentPrice = currentPrice + 0;
    let previousPrice =  newQuantity * (parseInt(itemPrice.querySelector('.retail').getAttribute('data-price')) / currentQuantity);
    let compareAtDiscount = previousPrice > currentPrice ? previousPrice - currentPrice : 0;
    cartTotalDiscount = cartTotalDiscount + compareAtDiscount;
    let discountData = JSON.parse(itemPrice.querySelector('.discount-allocation-data').innerText);
    let discountAmount = 0;
    let discountMessage = '';

    if(previousPrice == 0){
      previousPrice = originalCurrentPrice;
    }

    const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(currentPrice, previousPrice, 0, '', productHandle);
    let codeCurrentPrice = codeDiscountData.currentPrice;
    let codeLimit = codeDiscountData.discountCodeLimit;


    let exceedsLimit = false;
    if(perProductQuantities[`${productHandle}`] > codeLimit){
      exceedsLimit = true;
    }

    discountData.forEach((discountLine) => {
      if(discountLine.target_type == 'line_item' && discountLine.target_selection != 'all'){
        currentPrice = currentPrice - discountLine.amount;
        discountAmount = discountAmount + discountLine.amount
        discountMessage = `<p> with <strong>'${discountLine.title}'</strong></p>`;
      } else if(discountLine.target_type == 'line_item' && discountLine.target_selection == 'all'){
        orderLevelDiscountTotal = orderLevelDiscountTotal + discountLine.amount;
        orderLevelDiscountMessage = discountLine.title;
      }
    })

    if(codeCurrentPrice < currentPrice && exceedsLimit == false){
      discountAmount = previousPrice - codeCurrentPrice;
      currentPrice = codeCurrentPrice;
      discountMessage = codeDiscountData.discountMessage;
    }

    itemPrice.querySelector('span[data-price="deal"]').innerHTML = Shopify.formatMoney(currentPrice, Simplistic.formatMoney).split('.')[0].replace(' ','')
    itemPrice.querySelector('.deal').setAttribute('data-price', originalCurrentPrice);

    if(previousPrice != 0 && currentPrice < previousPrice){
      itemPrice.querySelector('span[data-price="retail"]').innerHTML = Shopify.formatMoney(previousPrice, Simplistic.formatMoney).split('.')[0].replace(' ','')
      itemPrice.querySelector('.retail').setAttribute('data-visible', 'true');
      itemPrice.querySelector('.retail').setAttribute('data-price', previousPrice);
    }

    let parentContainer = itemPrice.closest('.grid');
    if(discountMessage != '' && parentContainer && !parentContainer.querySelector('.cart-discount-code-message')){
      itemPrice.insertAdjacentHTML('afterend', `<div class="cart-discount-code-message">${discountMessage}</div>`);
    } else if(discountMessage != '' && parentContainer && parentContainer.querySelector('.cart-discount-code-message')) {
      parentContainer.querySelector('.cart-discount-code-message').innerHTML = discountMessage;
    }

    cartTotalOriginalPrice = cartTotalOriginalPrice + previousPrice;
    cartTotalDiscountedPrice = cartTotalDiscountedPrice + currentPrice;
    cartTotalDiscount = cartTotalDiscount + discountAmount;
  });

  let cartTotalContainer = document.querySelector(`${topSelector} .cart-subtotal`);

  if(orderLevelDiscountTotal > 0){
    cartTotalDiscountedPrice = cartTotalDiscountedPrice - orderLevelDiscountTotal;
    cartTotalDiscount = cartTotalDiscount + orderLevelDiscountTotal;
  }

  if(cartTotalContainer){cartTotalContainer.querySelector('.column.igSubtotal').innerHTML = `<span class="money">${Shopify.formatMoney(cartTotalDiscountedPrice, Simplistic.formatMoney)}</span>`;};

  if(cartTotalOriginalPrice > cartTotalDiscountedPrice){
    if(cartTotalContainer){
      cartTotalContainer.querySelector('.column.pre-tiered-discount-price').innerHTML = `<span class="money">${Shopify.formatMoney(cartTotalOriginalPrice, Simplistic.formatMoney)}</span>`;
      cartTotalContainer.querySelector('.column.pre-tiered-discount-price').setAttribute('data-display', 'true');
    }

    let cartSavingsMessage= document.querySelector(`${topSelector} .cart-subtotal-saving-message`);
    cartSavingsMessage.setAttribute('data-display', 'true');
    cartSavingsMessage.setAttribute('data-total-discount', cartTotalDiscount);
    cartSavingsMessage.querySelector('.column.savings-amount').innerHTML = `<span class="money">${Shopify.formatMoney(cartTotalDiscount, Simplistic.formatMoney)}</span>`;
  }

  if(orderLevelDiscountTotal > 0){
    let tieredDiscountMessage = document.querySelector(`${topSelector} .tiered_discount_message`);
    tieredDiscountMessage.innerHTML = `<p>${orderLevelDiscountMessage}</p>`;

    if(cartTotalContainer){
      cartTotalContainer.querySelector('.column.igSubtotal').setAttribute('data-tiered-discount', true);
    }
  }

  return cartTotalDiscountedPrice;
}

window.Branch.functions.fireOnUserInteraction = function(callback, scrollContainerSelectorClass, el, argument, argument2) {
  const scrollContainer = scrollContainerSelectorClass && el && el.closest(`${scrollContainerSelectorClass}`)
    ? el.closest(`${scrollContainerSelectorClass}`)
    : null;

  const container = scrollContainer || window;

  function getScrollTop() {
    if (scrollContainer) return scrollContainer.scrollTop;
    return window.scrollY || document.documentElement.scrollTop;
  }

  function isElementVisibleInContainer(el) {
    const elRect = el.getBoundingClientRect();
    const containerRect = (scrollContainer || document.documentElement).getBoundingClientRect();

    return (
      elRect.bottom > containerRect.top &&
      elRect.top < containerRect.bottom
    );
  }

  const alreadyScrolled = getScrollTop() > 0;
  const isVisible = el && isElementVisibleInContainer(el);

  const interactionEvents = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'pointerdown'];
  if (scrollContainer) {
    interactionEvents.push('scroll');
  } else {
    interactionEvents.push('scroll'); 
  }

  function onFirstUserInteraction() {
    interactionEvents.forEach(event => {
      if (event === 'scroll' && scrollContainer) {
        scrollContainer.removeEventListener(event, handleInteraction);
      } else {
        window.removeEventListener(event, handleInteraction);
      }
    });

    if (argument && argument2) {
      callback(argument, argument2);
    } else if (argument) {
      callback(argument);
    } else {
      callback();
    }
  }

  function handleInteraction() {
    onFirstUserInteraction();
  }

  if (alreadyScrolled || isVisible) {
    if (argument && argument2) {
      callback(argument, argument2);
    } else if (argument) {
      callback(argument);
    } else {
      callback();
    }
  } else {
    interactionEvents.forEach(event => {
      if (event === 'scroll' && scrollContainer) {
        scrollContainer.addEventListener(event, handleInteraction, { once: true });
      } else {
        window.addEventListener(event, handleInteraction, { once: true });
      }
    });
  }
};

window.Branch.functions.setupSwipeListener = function(element, callback, options = {}) {
  console.log('setupSwipeListener')
  const threshold = options.threshold ?? 50;
  const once = options.once ?? false; 

  let startX = 0;
  let startY = 0;
  let isTouch = false;

  function onStart(e) {
    isTouch = e.type === 'touchstart';
    const point = isTouch ? e.touches[0] : e;
    startX = point.clientX;
    startY = point.clientY;
  }

  function onEnd(e) {
    const point = isTouch ? e.changedTouches[0] : e;
    const deltaX = point.clientX - startX;
    const deltaY = point.clientY - startY;

    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > threshold) {
      const direction = deltaX > 0 ? 'right' : 'left';
      if (once) remove();
      callback(direction);
    }
  }

  function remove() {
    element.removeEventListener('mousedown', onStart);
    element.removeEventListener('mouseup', onEnd);
    element.removeEventListener('touchstart', onStart);
    element.removeEventListener('touchend', onEnd);
  }

  element.addEventListener('mousedown', onStart);
  element.addEventListener('mouseup', onEnd);
  element.addEventListener('touchstart', onStart);
  element.addEventListener('touchend', onEnd);

  return { remove };
}

window.Branch.functions.isScriptLoaded = function(src) {
  return Array.from(document.scripts).some(script => script.src === src);
}

isStylesheetLoaded = function(href) {
  return Array.from(document.styleSheets).some(sheet =>
    sheet.href === href
  );
}

window.Branch.functions.isHidden = function(el) {
  while (el) {
    const style = getComputedStyle(el);
    if (style.display === 'none') {
      return true;
    }
    el = el.parentElement;
  }
  return false;
}

window.Branch.functions.checkSwiperNavVisibility = function(){
  const totalSlides = this.slides.length;
  const slidesPerView = this.params.slidesPerView;

  const prevEl = this.navigation.prevEl;
  const nextEl = this.navigation.nextEl;

  if (totalSlides <= slidesPerView) {
    prevEl.style.display = 'none';
    nextEl.style.display = 'none';
  } else {
    prevEl.style.display = '';
    nextEl.style.display = '';
  }
}

window.Branch.functions.saleTagUpdate = function(variantId, variantSwatchValue, originalPrice, currentPrice, product, type){
      let discountMessage = '';

      if(originalPrice > currentPrice){
        discountMessage = `save ${percentageDiscount = Math.round(100 * ((originalPrice - currentPrice) / originalPrice))}%`;
      }

      if(type == "product"){
        if(document.querySelector(`#variant_metafield_values--${product.id}`)){
        const metafield_value = JSON.parse(document.querySelector(`#variant_metafield_values--${product.id}`).innerText)[`${variantId}`];

        let sales_tags = document.querySelectorAll(`.main-product-gallery[data-product-id="${ product.id }"] .sale`);
       
        if (metafield_value !== 'no_metafield_value'){
          discountMessage = metafield_value;
        } else if (sales_tags.length > 0 && sales_tags[0].getAttribute('data-mf-swatch-text') && sales_tags[0].getAttribute('data-mf-swatch-text') !== ""){
          discountMessage = sales_tags[0].getAttribute('data-mf-swatch-text');
        }

          if(discountCodeData.discount_code_1_product_handles.replaceAll(' ', '').split(",").includes(product.handle) && discountCodeData.discount_code_1_amount != undefined && discountCodeData.discount_code_1_amount > 0){
            if(discountCodeData.discount_code_1_special_swatch_text != ""){
              discountMessage = `${discountCodeData.discount_code_1_special_swatch_text}`;
            }
          } else if(discountCodeData.discount_code_2_product_handles.replaceAll(' ', '').split(",").includes(product.handle) && discountCodeData.discount_code_2_amount != undefined && discountCodeData.discount_code_2_amount > 0){
            if(discountCodeData.discount_code_2_special_swatch_text != ""){
              discountMessage = `${discountCodeData.discount_code_2_special_swatch_text}`;
            }
          }

        if(discountMessage !== '' && !variantSwatchValue){
          sales_tags.forEach((sales_tag) => {
            sales_tag.innerText = discountMessage;
            sales_tag.classList.add('sale--display');
          })
        } else {
          sales_tags.forEach((sales_tag) => {
            sales_tag.innerText = '';
            sales_tag.classList.remove('sale--display');
          })
        }
      };
      } else {
        let sales_tag = document.querySelector(`.bundle-builder-gallery .pre-set-bundle-image-container + .sale`);
        if(sales_tag){
          sales_tag.innerText = discountMessage;
          sales_tag.classList.add('sale--display');
          const nearestGalleryItem = sales_tag.closest('.bundle-builder-gallery__item');

          if (nearestGalleryItem && sales_tag.closest('.bundle-builder-gallery__preset-loading-image')) {
            nearestGalleryItem.appendChild(sales_tag);
          }
        }
      }
    }

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

window.Branch.functions.isIOSSafari = function() {
  const ua = navigator.userAgent;
  const isIos = isIOS();
  const isWebkit = /WebKit/.test(ua);
  const isChrome = /CriOS/.test(ua);
  const isFirefox = /FxiOS/.test(ua);
  const isEdge = /EdgiOS/.test(ua);
  
  // iOS Safari is webkit-based but not Chrome/Firefox/Edge on iOS
  return isIos && isWebkit && !isChrome && !isFirefox && !isEdge;
}